import { GLTRAN_INIT_LOADING, GLTRAN_INIT_SUCCESS, GLTRAN_INIT_FAIL } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import clone from 'clone'

export const initialState = {
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [GLTRAN_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [GLTRAN_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.initErr = []
  },
  [GLTRAN_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  }
}

const actions = {
  async glTranManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.glTranManagement
    commit(GLTRAN_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu
        }
        commit(GLTRAN_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(GLTRAN_INIT_FAIL, extractMessages(error))
      }
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
